import { api, CustomAxiosRequestConfig } from "./http-client";
import { LoginResponse, User } from "../interfaces/user.interface";
import { API_PATHS } from "../config/api.config";

export interface RegisterDto {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
}

export const authService = {
  getSetupStatus: async (): Promise<{ isSetup: boolean }> => {
    const response = await api.request<{ isSetup: boolean }>({
      url: API_PATHS.AUTH.SETUP_STATUS,
      method: "GET",
    });
    return response.data;
  },
  setup: async (data: any): Promise<void> => {
    await api.request({
      url: API_PATHS.AUTH.SETUP,
      method: "POST",
      data,
    });
  },
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await api.request<LoginResponse>({
      url: API_PATHS.AUTH.LOGIN,
      method: "POST",
      data: { email, password },
      skipAuthRedirect: true,
    });
    return response.data;
  },
  register: async (userData: RegisterDto): Promise<User> => {
    const response = await api.request<User>({
      url: API_PATHS.AUTH.REGISTER,
      method: "POST",
      data: userData,
    });
    return response.data;
  },
  getProfile: async (config?: CustomAxiosRequestConfig): Promise<User> => {
    const response = await api.request<User>({
      url: API_PATHS.AUTH.PROFILE,
      method: "GET",
      ...config,
    });
    return response.data;
  },
  logout: async (): Promise<void> => {
    await api.request({
      url: API_PATHS.AUTH.LOGOUT,
      method: "POST",
    });
  },
};
